import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";

const trustItems = ["IRATA", "Work at Height", "Industrial Projects", "Europe"];

const Header = () => {
  return (
    <header id="hero" className="site-hero d-flex align-items-center">
      <Container>
        <Row className="align-items-center g-5">
          <Col lg={7} xl={6} className="text-start">
            <div className="hero-content-panel">
              <p className="hero-kicker text-uppercase mb-3">
                Specialist Rope Access Contractor | IRATA Level 2 Rope Access Technician
              </p>
              <h1 className="hero-title fw-bold mb-4">
                IRATA Rope Access Technician for Industrial and Technical Projects
                Across Europe
              </h1>
              <p className="hero-copy lead mb-4">
                SUPPoland provides specialist rope access and work-at-height
                support for contractors, subcontractors and project teams working
                in industrial, construction and technical environments.
              </p>
              <div className="hero-actions d-flex flex-column flex-sm-row gap-3">
                <Button href="#contact" className="btn-cta-primary">
                  Send a Project Inquiry
                </Button>
                <Button href="#experience" className="btn-cta-secondary">
                  View Experience
                </Button>
              </div>
              <div className="trust-strip" aria-label="Key service signals">
                {trustItems.map((item) => (
                  <span className="trust-item" key={item}>
                    {item}
                  </span>
                ))}
              </div>
            </div>
          </Col>
          <Col lg={5} xl={6}>
            <figure className="hero-image-panel mb-0">
              <img
                src="/Images/header-bg.webp"
                alt="Rope access work at height on an industrial structure"
              />
            </figure>
          </Col>
        </Row>
      </Container>
    </header>
  );
};

export default Header;